import ScreenLoader from 'components/organismos/ScreenLoader';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackReservationClickApi } from 'api/onlineBookingV2Api';
import DialogComponents from './components/DialogComponents';
import { ReservationBookingOnlineContextProvider } from './context';
import EnterCustomerInformation from './pages/EnterCustomerInformation';
import ReceptionCompleted from './pages/ReceptionCompleted';
import StepConfirmationOfReservationDetail from './pages/StepConfirmationOfReservationDetail';
import StepDateAndTimeVisitSelection from './pages/StepDateAndTimeVisitSelection';
import StepsBeforeReservation from './pages/StepsBeforeReservation';
import useStyles from './styles';

function ReservationBookingOnlineV2() {
  const classes = useStyles();
  const location = useLocation();
  const urlSearchParam = new URLSearchParams(location.search);
  const currentStep = urlSearchParam.get('currentStep') || '';
  const companyCode = urlSearchParam.get('companyCode') || '';
  const courseCode = urlSearchParam.get('courseCode') || '';
  const mediaCode = urlSearchParam.get('mediaCode') || '';
  const gender = urlSearchParam.get('gender') || '';
  const serviceCode = urlSearchParam.get('serviceCode') || '';
  const trackingCode = urlSearchParam.get('trackingCode') || '';
  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'reservation_form_view',
      reservation_company_code: companyCode,
      reservation_media_code: mediaCode,
    });
  }, []);

  useEffect(() => {
    // 効果測定URL（trackingCode）経由の予約ページ表示をクリックとして計測する
    // 同一ブラウザでのリロード・短時間の再表示による二重カウントを防ぐため、
    // 計測した trackingCode と有効期限（24時間）を localStorage に記録し、
    // 期限切れまたは未計測の場合のみ送信する
    if (!companyCode || !trackingCode) return;
    const trackedKey = `tracking_click:${companyCode}:${trackingCode}`;
    const dedupWindowMs = 24 * 60 * 60 * 1000;
    try {
      const expireAt = Number(localStorage.getItem(trackedKey));
      if (expireAt && expireAt > Date.now()) return;
      localStorage.setItem(trackedKey, String(Date.now() + dedupWindowMs));
    } catch {
      // localStorage が使用できない環境では従来どおり計測する
    }
    trackReservationClickApi(companyCode, trackingCode).catch(() => {
      // 送信失敗時は次回の再試行を許可するため記録を取り消す
      try {
        localStorage.removeItem(trackedKey);
      } catch {
        // 取り消しに失敗しても致命的ではないため無視する
      }
    });
  }, [companyCode, trackingCode]);

  const renderCurrentSelection = (step:string) => {
    switch (step) {
      case '2':
        return <StepDateAndTimeVisitSelection companyCode={companyCode} courseCode={courseCode} mediaCode={mediaCode} gender={gender} serviceCode={serviceCode} trackingCode={trackingCode} />;
      case '3':
        return <EnterCustomerInformation companyCode={companyCode} courseCode={courseCode} mediaCode={mediaCode} gender={gender} serviceCode={serviceCode} trackingCode={trackingCode} />;
      case '4':
        return <StepConfirmationOfReservationDetail companyCode={companyCode} courseCode={courseCode} mediaCode={mediaCode} gender={gender} serviceCode={serviceCode} trackingCode={trackingCode} />;
      case '5':
        return <ReceptionCompleted companyCode={companyCode} courseCode={courseCode} mediaCode={mediaCode} gender={gender} serviceCode={serviceCode} trackingCode={trackingCode} />;
      default:
        return <StepsBeforeReservation companyCode={companyCode} courseCode={courseCode} mediaCode={mediaCode} gender={gender} serviceCode={serviceCode} trackingCode={trackingCode} />;
    }
  };

  return (
    <ScreenLoader>
      <ReservationBookingOnlineContextProvider>
        <div className={classes.root}>
          {renderCurrentSelection(currentStep)}
          <DialogComponents />
        </div>
      </ReservationBookingOnlineContextProvider>
    </ScreenLoader>
  );
}

export default ReservationBookingOnlineV2;
